import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=a6f2468c&scoped=true"
import script from "./LegendItem.vue?vue&type=script&lang=ts"
export * from "./LegendItem.vue?vue&type=script&lang=ts"
import style0 from "./LegendItem.vue?vue&type=style&index=0&id=a6f2468c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f2468c",
  null
  
)

export default component.exports